import Skeleton from 'react-loading-skeleton'

type Props = {
  width?: string
  height?: string
  count?: number
}
const LoadingSkeleton: React.FC<Props> = ({ width, height, count }) => {
  return <Skeleton width={width || '100%'} height={height} count={count} />
}

export default LoadingSkeleton
